import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { ContentBlock, ContentState, convertFromRaw, convertToRaw, EditorState, genKey } from "draft-js";
import { loading, ready } from "../../../custom_api/api_utils";
import { Loader } from "../loader";
import { ReCaptchaForm } from "../recaptcha_form";
import { RichTextEditor } from "../rich_text_editor";
const draftToHtml = require("draftjs-to-html");
const initialBlock = {
    key: '',
    type: 'blockquote',
    text: '',
    depth: 0,
    inlineStyleRanges: [],
    entityRanges: []
};
export const ReactionsLayout = (props)=>{
    const { reactions, authorEmail, authorScreenName, editorState, validationMessages, submitting, addReaction, updateEditorState, updateAuthorEmail, updateAuthorScreenName, updateValidationMessages, pushDataLayer } = props;
    if (loading(reactions)) return /*#__PURE__*/ _jsx(Loader, {});
    if (!ready(reactions)) return /*#__PURE__*/ _jsx("aside", {
        className: "blog-reactions br",
        "aria-live": "polite",
        children: /*#__PURE__*/ _jsx("div", {
            className: "br__inner container--sg align--center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "text--styled weight--bold container--s",
                children: "Het is helaas niet gelukt om reacties te laden. Probeer het later nog eens."
            })
        })
    });
    const { access, items } = reactions.value;
    if (access == 'Hidden') return /*#__PURE__*/ _jsx(_Fragment, {});
    const replyTo = (reaction)=>{
        const quoteIntroduction = `${reaction.name} zei op ${reaction.date.format('D MMM YYYY')}`;
        const quoteIntroductionBlocks = [
            new ContentBlock({
                key: genKey(),
                text: quoteIntroduction,
                type: 'unstyled'
            })
        ];
        const rawContent = JSON.parse(reaction.body);
        // Reduce all blocks into one blockquote
        rawContent.blocks = [
            rawContent.blocks.reduce((acc, block, index)=>{
                let blockText = block.text;
                // Can't figure out why, but the offset needs a bump after the first block
                let offset = acc.text.length ? acc.text.length + 1 : 0;
                let blockInlineStyleRanges = block.inlineStyleRanges.map((r)=>({
                        ...r,
                        offset: r.offset + offset
                    }));
                // Nested quotes are not an option, but let's at least add some hint to it by adding `>`
                if (block.type == 'blockquote') {
                    blockText = block.text.trim().split('\n').map((l)=>'> ' + l).join('\n');
                    // Retaining the styling on nested quotes while adding `>` is too complex, so we're just dropping these
                    blockInlineStyleRanges = [];
                }
                const text = `${acc.text}\n${blockText}`.trim();
                const inlineStyleRanges = acc.inlineStyleRanges.concat(blockInlineStyleRanges);
                return {
                    ...acc,
                    text,
                    inlineStyleRanges
                };
            }, initialBlock)
        ];
        const finalBlockArray = quoteIntroductionBlocks // start with introduction to quote
        .concat(convertFromRaw(rawContent).getBlocksAsArray()) // append quote block
        .concat(editorState.getCurrentContent().getBlocksAsArray()) // append original editor blocks
        ;
        const newContentState = ContentState.createFromBlockArray(finalBlockArray);
        const newEditorState = EditorState.createWithContent(newContentState);
        const focusedEditorState = EditorState.moveFocusToEnd(newEditorState);
        updateEditorState(focusedEditorState);
        document.getElementById("authorEmailInput").scrollIntoView({
            behavior: "smooth"
        });
        pushDataLayer('Reactie geciteerd');
    };
    return /*#__PURE__*/ _jsx("aside", {
        className: "blog-reactions br",
        "aria-live": "polite",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "br__inner container--sg align--center",
            children: [
                /*#__PURE__*/ _jsx("header", {
                    className: "br__header",
                    children: /*#__PURE__*/ _jsxs("h2", {
                        className: "br__title title--m",
                        children: [
                            items.length,
                            " ",
                            items.length === 1 ? 'reactie' : 'reacties'
                        ]
                    })
                }),
                items.length > 0 ? /*#__PURE__*/ _jsx("div", {
                    className: "br__content",
                    children: /*#__PURE__*/ _jsx("ol", {
                        className: "br__list",
                        children: items.map((r, i)=>/*#__PURE__*/ _jsx("li", {
                                className: "br__item",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "blog-reaction-item bri",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "bri__meta",
                                            children: [
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: r.name
                                                }),
                                                " op ",
                                                /*#__PURE__*/ _jsx("time", {
                                                    dateTime: r.date.toISOString(),
                                                    children: r.date.format('D MMM YYYY')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "bri__content",
                                            children: /*#__PURE__*/ _jsx("p", {
                                                className: "bri__text text--styled",
                                                dangerouslySetInnerHTML: {
                                                    __html: draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(r.body))).getCurrentContent()))
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("button", {
                                            onClick: (e)=>replyTo(r),
                                            className: "button button--tertiary",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "button__label",
                                                children: "Antwoord"
                                            })
                                        })
                                    ]
                                })
                            }, `reaction-${i}`))
                    })
                }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                access == 'Open' && /*#__PURE__*/ _jsx(ReCaptchaForm, {
                    onSubmitOkay: (e, token)=>{
                        const reaction = {
                            name: authorScreenName,
                            email: authorEmail,
                            body: JSON.stringify(convertToRaw(editorState.getCurrentContent()))
                        };
                        addReaction(token, reaction, ()=>pushDataLayer('Reactie geplaatst'));
                    },
                    onErrored: updateValidationMessages.bind(this),
                    sitekey: document.getElementsByName("__GoogleCaptchaToken").length > 0 ? document.getElementsByName("__GoogleCaptchaToken")[0].value : "EMPTY",
                    className: "blog-reactions-form brf",
                    buttonText: /*#__PURE__*/ _jsx("span", {
                        className: "button__label",
                        children: "Reageer"
                    }),
                    buttonClass: "button button--primary",
                    buttonDisabled: submitting,
                    badge: "inline",
                    size: "invisible",
                    children: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "brf__field brf__field--half",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "brf__label",
                                        htmlFor: "authorScreenName",
                                        children: "Naam"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        id: "authorScreenName",
                                        className: "brf__input",
                                        onChange: (e)=>updateAuthorScreenName(e.target.value),
                                        placeholder: "Naam",
                                        value: authorScreenName,
                                        disabled: submitting
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "brf__field",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "brf__label",
                                        htmlFor: "authorEmailInput",
                                        children: "E-mail"
                                    }),
                                    /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        id: "authorEmailInput",
                                        className: "brf__input",
                                        onChange: (e)=>updateAuthorEmail(e.target.value),
                                        placeholder: "E-mail",
                                        value: authorEmail,
                                        disabled: submitting
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "brf__field",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        htmlFor: "bodyInput",
                                        children: "Bericht"
                                    }),
                                    /*#__PURE__*/ _jsx(RichTextEditor, {
                                        editorState: editorState,
                                        onNewEditorState: updateEditorState,
                                        disabled: submitting,
                                        placeholder: "Bericht"
                                    })
                                ]
                            }),
                            validationMessages.length > 0 && /*#__PURE__*/ _jsx("div", {
                                className: "brf__errors",
                                role: "alert",
                                children: validationMessages.map((m, i)=>/*#__PURE__*/ _jsx("p", {
                                        className: `${m.kind == "error" ? "brf__error form__error" : ""} text--xs`,
                                        children: m.message
                                    }, 'message-' + i))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
